import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { BRAND } from './shared/service/organization.services';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  constructor(private titleService: Title) {
  }

  ngOnInit(): void {
    this.titleService.setTitle(BRAND.BRAND_PORTAL_NAME);
  }
}
